document.addEventListener('DOMContentLoaded', function () {
  var burger = document.getElementById('burgerToggle');
  var navLinks = document.querySelector('.nav-links');
  if (burger) {
    burger.addEventListener('click', function () {
      navLinks.classList.toggle('open');
    });
  }
});

window.MoversClo = {
  quickAdd: function (variantId, btn) {
    if (!variantId) return;
    btn.textContent = 'Adding...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        btn.textContent = 'Added ✓';
        setTimeout(function () { btn.textContent = 'Quick Add'; }, 1500);
      })
      .catch(function () { btn.textContent = 'Error'; });
  }
};

window.MoversSlideshow = (function () {
  var state = {};

  function show(id, i) {
    var root = document.getElementById('slideshow-' + id);
    if (!root) return;
    var slides = root.querySelectorAll('.slide');
    var dots = root.querySelectorAll('.dot');
    var total = slides.length;
    if (!total) return;
    var newIndex = ((i % total) + total) % total;
    slides.forEach(function (s, idx) { s.classList.toggle('active', idx === newIndex); });
    dots.forEach(function (d, idx) { d.classList.toggle('active', idx === newIndex); });
    if (state[id]) state[id].index = newIndex;
  }

  function next(id) { show(id, (state[id] ? state[id].index : 0) + 1); }
  function prev(id) { show(id, (state[id] ? state[id].index : 0) - 1); }
  function go(id, i) { show(id, i); }

  function init(id) {
    var root = document.getElementById('slideshow-' + id);
    if (!root) return;
    var total = root.querySelectorAll('.slide').length;
    state[id] = { index: 0, timer: null };
    if (total > 1) {
      state[id].timer = setInterval(function () { next(id); }, 5500);
      root.addEventListener('mouseenter', function () { clearInterval(state[id].timer); });
      root.addEventListener('mouseleave', function () {
        state[id].timer = setInterval(function () { next(id); }, 5500);
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.slideshow').forEach(function (el) {
      init(el.id.replace('slideshow-', ''));
    });
  });

  return { next: next, prev: prev, go: go };
})();